import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginLeft: theme.spacing(2),
  },
}));
function UserDashboard(props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography component="h1" variant="h4" className={classes.heading}>
        Welcome {props.userResp.fullName}
      </Typography>
      <br />
    </React.Fragment>
  );
}

export default UserDashboard;
